import { Button } from "@chakra-ui/button";
import { Heading, Stack, VStack } from "@chakra-ui/layout";
import { chakra } from "@chakra-ui/system";
import { yupResolver } from "@hookform/resolvers/yup";
import { useToast } from "@chakra-ui/react";
import React from "react";
import { Text } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { apiErrorHandler } from "utils/errors";
import * as yup from "yup";
import { resetPassword } from "..";
import { Layout } from "../components/Layout";
import { LoginField } from "../components/LoginField";

type ResetFormValues = {
  email: string;
};

const schema = yup.object({
  email: yup.string().email().required(),
});

export const LostPassword: React.FC = () => {
  const toast = useToast();

  const { register, setError, formState, handleSubmit } =
    useForm<ResetFormValues>({
      resolver: schema && yupResolver(schema),
    });
  const { mutate, isLoading } = useMutation({
    mutationFn: resetPassword,
    onSuccess: (data) => {
      toast({
        description:
          "Un email vous a été envoyé afin de continuer la procédure de réinitialisation de votre mot de passe.",
        status: "success",
        duration: 9000,
        isClosable: true,
      });
    },
    onError: (e: any) => apiErrorHandler(e, setError),
  });

  return (
    <Layout title="Mot de passe oublié ?">
      <VStack
        spacing={4}
        justify="center"
        w={["full", null, null, "container.lg"]}
        p={["20px"]}
      >
        <Heading
          fontWeight="normal"
          fontSize="20px"
          color="brand.primary"
          mt={8}
          mb={16}
        >
          Vous avez oublié votre mot de passe ?
        </Heading>
        <Text
          fontWeight="normal"
          fontSize="16px"
          color="brand.primary"
          textAlign="center"
        >
          Veuillez nous indiquez votre adresse e-mail, nous allons vous envoyer
          la marche à suivre.
        </Text>
        <chakra.form
          id="register"
          onSubmit={handleSubmit(async (values: any) => {
            mutate(values);
          })}
          width={["full", "350px"]}
          maxWidth={"350px"}
        >
          <>
            <Stack
              spacing="24px"
              direction={"column"}
              mt={10}
              mb={2}
              px={["20px"]}
            >
              <LoginField
                error={formState.errors["email"]}
                registration={register("email")}
                placeholder={"Email"}
              />
            </Stack>
            <Button
              bg="brand.primary"
              type="submit"
              h="48px"
              isLoading={isLoading}
              mt={10}
            >
              Réinitialiser
            </Button>
          </>
        </chakra.form>
      </VStack>
    </Layout>
  );
};
